import { TrendingUp, Package, Clock } from "lucide-react";
import styles from "~/styles/burn-rate.module.css";

interface BreakEvenCardProps {
  value: number | string;
  label: string;
  isServices: boolean;
}

export function BreakEvenCard({ value, label, isServices }: BreakEvenCardProps) {
  const Icon = isServices ? Clock : Package;
  return (
    <div className={styles.chartCard}>
      <p className={styles.chartTitle}>Punto de equilibrio</p>
      <div className={styles.breakEvenContent}>
        <div className={styles.breakEvenIcon}>
          <Icon size={20} strokeWidth={1.5} />
        </div>
        <div className={styles.breakEvenText}>
          <span className={styles.breakEvenValue}>{value}</span>
          <span className={styles.breakEvenLabel}>{label}</span>
        </div>
      </div>
      <div className={styles.breakEvenTrend}>
        <TrendingUp size={14} strokeWidth={1.5} />
        <span>Meta mensual</span>
      </div>
    </div>
  );
}
